import React from 'react';
import { Eyebrow } from './Eyebrow';
import { CTAButton } from './CTAButton';
import { assets } from '../data/assets';
import { heroStats, pricing } from '../data/content';
import { heroImageSizes, heroImageWidths, resizedImage, resizedSrcSet } from '../utils/image';
export function HeroSection() {
  return <section id="hero" className="bg-ivory pt-5 md:pt-10 pb-10 md:pb-14 px-4" data-id="element-104" data-mp="28tcwfplg451h">
      <div className="max-w-4xl mx-auto text-center" data-id="element-105" data-mp="2wjyz11cokx43">
        <Eyebrow data-id="element-106" data-mp="2wkijoptptzlt">Pausa Propia · Biblioteca digital de arteterapia</Eyebrow>

        <h1 className="mt-3 md:mt-5 font-serif text-[1.6rem] md:text-[2.6rem] lg:text-[3rem] font-bold text-forest leading-[1.12] md:leading-[1.1]" style={{
        fontSize: "19px"
      }} data-id="element-107" data-mp="30k0toqk00q9v">
          En 7 días, pasa del ruido mental a tener{' '}
          <span className="italic text-terracotta-deep" style={{
          fontSize: "24px"
        }} data-id="element-108" data-mp="2rqw4or02xjmu">una pausa creativa</span> para calmarte,
          expresar lo que sientes y volver a ti.
        </h1>

        <p className="mt-3 md:mt-5 font-sans text-[14px] md:text-lg text-forest/75 max-w-2xl mx-auto leading-[1.45] md:leading-relaxed" style={{
        fontSize: "13px"
      }} data-id="element-109" data-mp="3kbe8de2vkeou">
          Actividades guiadas con color, acuarela, collage y expresión visual. Puedes comenzar con
          solo 10 minutos y no necesitas saber dibujar.
        </p>

        <div className="mt-4 md:mt-6 mb-4 md:mb-6" data-id="element-110" data-mp="2kev8j62bnt5t">
          <img src={resizedImage(assets.heroMockup, 380)} srcSet={resizedSrcSet(assets.heroMockup, heroImageWidths)} sizes={heroImageSizes} alt="Biblioteca de Arteterapia Pausa Propia: tres libros y dos bonus digitales" className="w-full max-w-[330px] md:max-w-xl mx-auto rounded-2xl shadow-soft object-contain" fetchPriority="high" decoding="async" width={1080} height={1080} style={{
          height: "215px"
        }} data-id="element-111" data-mp="2kdaedhjx6c8h" />
        </div>

        <div className="inline-flex items-center gap-3 bg-white rounded-full pl-5 pr-2 py-2 border border-sand-deep shadow-soft" data-id="element-112" data-mp="18rlfxdvgqgfw">
          <s className="font-sans text-sm text-forest/55" data-id="element-113" data-mp="38ummofnqemqp">{pricing.regular}</s>
          <span className="font-serif text-2xl md:text-3xl font-bold text-forest leading-none" data-id="element-114" data-mp="3drmjs12lsf5o">
            {pricing.launch}
          </span>
          <span className="rounded-full bg-sage-light px-2.5 py-1 font-sans text-[10px] font-bold tracking-wider text-sage-deep" data-id="element-115" data-mp="3iq7k00huuyu4">
            PAGO ÚNICO
          </span>
        </div>
        <p className="mt-2 font-sans text-[11px] md:text-xs text-forest/60 max-w-sm mx-auto" data-id="element-116" data-mp="3rrnvkbkep6zx">
          El importe puede visualizarse en tu moneda local según tu país y método de pago.
        </p>

        <div className="mt-4 md:mt-5" data-id="element-117" data-mp="5d4h6evflrtg">
          <CTAButton label={`QUIERO MI BIBLIOTECA PAUSA PROPIA — ${pricing.launch} →`} mobileLabel={`QUIERO MI BIBLIOTECA — ${pricing.launch} →`} data-id="element-118" data-mp="abpi6giicfiy" />
        </div>
        <p className="mt-2.5 font-sans text-[12px] md:text-sm text-forest/65" data-id="element-119" data-mp="ebg4o81049ho">
          Acceso inmediato · Sin suscripción · 100% digital
        </p>

        <dl className="mt-8 md:mt-10 grid grid-cols-2 md:grid-cols-4 gap-y-5 bg-white rounded-2xl border border-sand-deep shadow-soft py-5 md:py-6" data-id="element-120" data-mp="23v7mdphid9ws">
          {heroStats.map(stat => <div key={stat.label} className="flex flex-col items-center" data-id="element-121" data-mp="1uurl8mo8mev3">
              <dt className="order-2 mt-1 font-sans text-[11px] md:text-xs font-semibold uppercase tracking-wider text-forest/60" data-id="element-122" data-mp="1puwv4lcadtb3">
                {stat.label}
              </dt>
              <dd className="order-1 font-serif text-3xl md:text-4xl font-bold text-forest leading-none" data-id="element-123" data-mp="2mmqnfqrz2dw6">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}